import {createAction} from "@reduxjs/toolkit";

import {UserSource} from "../../tracking/tracking_utils/user_source";
import {IStartRegistrationFlowPayload, RegistrationFlowStep, RegistrationMethod, SocialMediaType} from "../state/registration_flow_slice";
import {AuthActionType} from "../types/AuthActionType";

export type AuthOrigin = "google_one_tap";

export interface IPostAuthFlowContext {
    flowWasActive: boolean;
    currentStep?: RegistrationFlowStep;
    registrationFlow: IStartRegistrationFlowPayload;
}

export interface IAuthSucceededPayload {
    type: AuthActionType;
    userSource: UserSource;
    gtmSourceSection?: string;
    registrationMethod: RegistrationMethod;
    socialMediaType?: SocialMediaType;
    authOrigin?: AuthOrigin;
    postAuthFlowContext?: IPostAuthFlowContext;
}

/**
 * Event dispatched when user authentication (login or registration) succeeds.
 */
export const authSucceeded = createAction<IAuthSucceededPayload>("auth/succeeded");
import {createAction} from "@reduxjs/toolkit";

import {UserSource} from "../../tracking/tracking_utils/user_source";
import {IStartRegistrationFlowPayload, RegistrationFlowStep, RegistrationMethod, SocialMediaType} from "../state/registration_flow_slice";
import {AuthActionType} from "../types/AuthActionType";

export type AuthOrigin = "google_one_tap";

export interface IPostAuthFlowContext {
    flowWasActive: boolean;
    currentStep?: RegistrationFlowStep;
    registrationFlow: IStartRegistrationFlowPayload;
}

export interface IAuthSucceededPayload {
    type: AuthActionType;
    userSource: UserSource;
    gtmSourceSection?: string;
    registrationMethod: RegistrationMethod;
    socialMediaType?: SocialMediaType;
    authOrigin?: AuthOrigin;
    postAuthFlowContext?: IPostAuthFlowContext;
}

/**
 * Event dispatched when user authentication (login or registration) succeeds.
 */
export const authSucceeded = createAction<IAuthSucceededPayload>("auth/succeeded");
